import type { ItemsAppInterface } from '../vite-env';

/** Bounds a save that Learnosity never acknowledges on a slow or offline connection. */
const LEARNOSITY_SAVE_TIMEOUT_MS = 15_000;

/**
 * Resolves true only when Learnosity confirms that responses were persisted.
 * Questions API queues a single save while another is in flight, so a superseded
 * call never invokes its callbacks; the timeout turns that silence into a failure.
 */
export function saveLearnosityResponses(itemsApp: Pick<ItemsAppInterface, 'save'>): Promise<boolean> {
  return new Promise(resolve => {
    let settled = false;
    const settle = (saved: boolean) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      resolve(saved);
    };
    const timer = setTimeout(() => settle(false), LEARNOSITY_SAVE_TIMEOUT_MS);
    try {
      itemsApp.save({ success: () => settle(true), error: () => settle(false) });
    } catch {
      settle(false);
    }
  });
}
